module.exports = __webpack_public_path__ + "static/media/circumference_dog_french.5adfa4b6.png";